// React
import { useState } from "react";

// Components
import Table from "../table/Table";
import Spinner from "../common/Spinner";

// API
import { useSystemDashboardCostReports } from "../../api/projects/ProjectAPI";

// Functions
import { countReports } from "./SystemDashboard.functions";
import ExportSystemDashboard from "./ExportSystemDashboard";
import { columns } from "./SystemDashboardCostReportTable.functions";
import { tranStr } from "../../utils/translation";
import isEmpty from "../../validation/is-empty";

// Style
import "./SystemDashboardTable.css";

export default function SystemDashboardCostReportTable() {
  const { systemDashboardCostReports } = useSystemDashboardCostReports();

  // Table Row Selection
  const [selectedChecked, setSelectedChecked] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [modal, setModal] = useState(false);

  if (
    isEmpty(systemDashboardCostReports.data) &&
    systemDashboardCostReports.loading
  ) {
    return (
      <div className="toggle-button-text-container">
        <Spinner />
      </div>
    );
  }

  const { totalCostReports } = countReports(systemDashboardCostReports.data);

  return (
    <div className="toggle-button-text-container">
      <p>
        <b>Project Cost Report</b>
      </p>
      <p>
        <b>Total Cost Reports: {totalCostReports}</b>
      </p>
      <Table
        title={tranStr("Cost Plan Table")}
        tableArray={systemDashboardCostReports.data}
        columns={columns()}
        tableSize={15}
        isTitleDisabled={true}
        isTotalDisabled={true}
        // Checked Selection
        checked={selectedChecked}
        setChecked={setSelectedChecked}
        // Row Selection
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        // Modal Control
        modal={modal}
        setModal={setModal}
      />
      <ExportSystemDashboard
        projects={systemDashboardCostReports.data}
        inputMode={"COSTREPORT"}
      />
    </div>
  );
}
